export default __webpack_public_path__ + "static/media/Fall_09.0ea411cb.png";